module.exports = __webpack_public_path__ + "static/media/triangle.582d7cc0.svg";